
import {Prop, Vue, Component, Watch} from "vue-property-decorator";
import {getFiledCourseList, FiledCourseSingle, cancelFiledCourse} from "@/apis/courseList/courseList";
import CourseDemo from '@/components/courseCell/courseDemo.vue';
import {
  CourseItem,
} from '@/apis/courseList/courseList';
import i18n from '@/lang/index';

interface ActionSheetItem {
  name: string;
}
@Component({
   components: {
    CourseDemo
  }
})
export default class  createCourseFromDemo extends Vue{
  private name = "filedCourse"
  private loading = true;
  private filedCourseList:Array<FiledCourseSingle> = []
  private actionsArray: Array<ActionSheetItem> = [];
  private isShowActionSheet:boolean = false;
  private courseItemCache: FiledCourseSingle = { role: 0 } as FiledCourseSingle;

  mounted() {
    this.getFiledCourseList();
  }

  handleItemMoreActions(item:FiledCourseSingle){
    this.courseItemCache = item;
    setTimeout(() => {
      let tempActionsArray: Array<ActionSheetItem> = [];
      tempActionsArray = [{ name: i18n.t('Home.建课') as string }];
      this.actionsArray = tempActionsArray;
      this.isShowActionSheet = true;
    }, 1);
  }

  onSelect(item: ActionSheetItem) {
    switch (item.name) {
      case i18n.t('Home.建课'):
        this.cancelFiledCourse(this.courseItemCache)
        break;
    }
  }

  getFiledCourseList() {
    this.loading = true;
    getFiledCourseList().then(res => {
      this.loading = false;
      this.filedCourseList = res.lists;
      this.$forceUpdate();
    })
  }
  cancelFiledCourse(item: FiledCourseSingle) {
    this.$dialog.confirm({
      confirmButtonText: i18n.t('Common.确定') as string,
      cancelButtonText: i18n.t('Common.取消') as string,
      showCancelButton: true,
      title: `${i18n.t('Home.要创建')}'${item.coursename}'吗?`,
      message: `${i18n.t('Home.开启您的轻松建课之旅')}`
    }).then(() => {
      cancelFiledCourse({ courseid: item.courseid, icontype: this.courseItemCache.icontype }).then(() => {
        this.$dialog.alert({
          title: i18n.t('Home.开启您的轻松建课之旅') as string,
        }).then(() => {
          this.$router.go(-1);
        })
      })
    }).catch()
  }
}
